import React from 'react';
import type { IconProps } from '@models/types';
import { styled } from '@mui/material/styles';

const Icon: React.FC<IconProps> = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        {...props}
    >
        <g clipPath='url(#clip0_6609_2468)'>
            <path
                d='M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z'
                fill='currentColor'
            />
            <path
                d='M11.9941 12.3818C15.9999 12.3818 16.9883 13.8812 16.9883 15.8789V16.8877C16.9883 17.5191 16.4091 18.1105 15.7842 18.2012C14.8257 18.3402 13.4147 18.501 12 18.501C10.3723 18.501 8.74436 18.2886 7.80664 18.1406C7.336 18.0662 7.00004 17.6572 7 17.1807V15.8789C7.00001 14.0005 7.73251 12.3819 11.9941 12.3818ZM11.9941 6C13.3732 6 14.4912 7.11797 14.4912 8.49707C14.4912 9.87619 13.3733 10.9941 11.9941 10.9941C10.6151 10.9941 9.49707 9.87614 9.49707 8.49707C9.49709 7.11802 10.6151 6.00007 11.9941 6Z'
                fill='white'
            />
            <circle cx='19' cy='19' r='5.5' fill='currentColor' stroke='white' />
            <path d='M19 16V22' stroke='white' strokeWidth='1.5' />
            <path d='M16 19H22' stroke='white' strokeWidth='1.5' />
        </g>
        <defs>
            <clipPath id='clip0_6609_2468'>
                <rect width='24' height='24' fill='white' />
            </clipPath>
        </defs>
    </svg>
);

export const PersonWithPlusIcon = styled(Icon)({});
